const algoliaIndices = {
  mainIndexV1: process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX,
  baseSalesIndex: process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX.replace("swap", "sales"),
  mainIndexV2: process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2,
};

export default algoliaIndices;
